// Map #6 Ember Wastes, audio half. A basalt plateau ringed by lava under an erupting sky (night by default).
// Ambience: a deep volcanic rumble under a hot roaring wind and a fizzing ember sizzle; lava blorping, steam vents hissing,
// crust cracking as it cools, eruption rumbles and far booms, cinders tumbling down the slopes. The lava (blorps, sizzle) is
// loudest at night; the hazy day look trades it for more hot wind.
// Music: C phrygian war drums, 126 bpm: a distorted chugging bass over a low saw drone, dark stabs, a wailing saw lead and a
// taiko kit that doubles up when the boss is out.
import { MODES, type MapAudioDef } from '../../audio/mapAudioDef';

export const AUDIO: MapAudioDef = {
  id: 'ember-wastes',
  ambience: {
    level: 0.7,
    beds: [
      { src: 'brown', filter: 'lowpass', freq: 90, q: 0.8, gain: 1, gust: { depth: 0.4, every: [3, 7], sweep: 1.4 } },
      { src: 'pink', filter: 'bandpass', freq: 450, q: 0.7, gain: 0.3, day: 1.25, night: 0.9, storm: 1, gust: { depth: 0.5, every: [2, 5], sweep: 1.5 } },
      { src: 'white', filter: 'bandpass', freq: 3000, q: 0.8, gain: 0.05, day: 0.7, night: 1.2, gust: { depth: 0.9, every: [0.6, 2] } },
    ],
    events: [
      { kind: 'bubble', every: [3, 7], gain: 0.2, day: 0.6, night: 1.1, voices: 2, pitch: 0.8 },
      { kind: 'hiss', every: [7, 15], gain: 0.11, storm: 1 },
      { kind: 'crack', every: [5, 11], gain: 0.14, pitch: 0.7 },
      { kind: 'rumble', every: [18, 35], gain: 0.35 },
      { kind: 'thunder', every: [30, 60], gain: 0.3, echo: 0.4 },
      { kind: 'rockfall', every: [15, 30], gain: 0.1, pitch: 0.8 },
    ],
    echo: { l: 0.33, r: 0.5, fb: 0.35, damp: 1500, wet: 0.6 },
  },
  music: {
    mood: 'molten war drums (C phrygian, 126 bpm)',
    score: {
      bpm: 126, steps: 16, root: 48, mode: MODES.phrygian, progression: [0, 1, 0, 6, 0, 1, 5, 6],
      pad: { wave: 'sawtooth', voices: 3, detune: 10, cutoff: 900, q: 1, gain: 0.06, octave: 1, send: 0.25 },
      drone: { wave: 'sawtooth', notes: [0, 7], cutoff: 300, gain: 0.05, octave: -1 },
      bass: { wave: 'sawtooth', detune: 9, drive: 3, cutoff: 700, q: 1.5, env: 2, atk: 0.003, dec: 0.12, sus: 0.4, rel: 0.05, gain: 0.24, octave: -1, legato: 0.7,
        pattern: '1.11.1.11.1.11.5', hot: '11111111111.1.8.' },
      arp: { wave: 'sawtooth', cutoff: 1600, env: 2, atk: 0.003, dec: 0.15, sus: 0.2, rel: 0.06, gain: 0.065, octave: 1, send: 0.3,
        pattern: [-1, -1, 0, -1, -1, -1, 2, -1, -1, -1, 1, -1, -1, -1, 3, -1], hot: [-1, 0, -1, 2, -1, 1, -1, 3, -1, 0, -1, 2, -1, 4, -1, 3] },
      lead: { wave: 'sawtooth', detune: 8, cutoff: 2600, env: 0.7, atk: 0.02, dec: 0.3, sus: 0.7, rel: 0.2, gain: 0.07, octave: 1, send: 0.3,
        vibrato: { rate: 6, cents: 20 }, bars: [4, 5, 6, 7],
        motifs: [
          { notes: [[0, 3], [1, 3], [0, 2], [-1, 2], [0, 6]] },
          { notes: [[4, 4], [3, 2], [1, 2], [0, 8]] },
          { notes: [[2, 2], [1, 2], [0, 2], [1, 2], [2, 4], [4, 4]] },
          { notes: [[7, 6], [5, 2], [4, 4], [1, 4]] },
        ] },
      drums: { kit: 'taiko', gain: 1,
        main: { kick: 'X..x..X.X..x..X.', tom: '....X.......X...', snare: '......x.......x.', hat: '..x...x...x...x.' },
        fill: { tom: '........X.X.XXXX' },
        hot: { kick: 'X.xX.xX.X.xX.xX.', tom: '....X..x....X.XX', snare: '..x...x...x...x.', hat: 'xxxxxxxxxxxxxxxx' } },
      echo: { steps: 3, fb: 0.3, wet: 0.15, damp: 2000 },
      level: 0.4,
    },
  },
};
